var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.isLoading)?_c('loading-spinner'):_vm._e(),(!_vm.isLoading)?_c('div',{staticClass:"container-fluid col-xs-12 col-sm-12 col-md-12 col-lg-10"},[_c('applicant-selection-header'),_c('app-navigation',{attrs:{"navigation-buttons":_vm.navigationButtons}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }